<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {BoosterKind} from "@/modules/redactor/models/booster/BoosterKind";

export default {
  name: "r-booster-kind",
  props: {
    model: VueTypes.instanceOf(BoosterKind),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return BoosterKind.getValues();
    }
  }
}
</script>